import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.trim.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('section', {
    staticClass: "product-example-picker",
    attrs: {
      "aria-labelledby": "product-picker-title"
    }
  }, [_c('div', {
    staticClass: "product-picker-heading"
  }, [_vm._m(0), _vm.selectedProduct ? _c('button', {
    staticClass: "btn btn-xs btn-light-danger font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearSelection
    }
  }, [_vm._v(" Limpar ")]) : _vm._e()]), _vm.selectedProduct ? _c('article', {
    staticClass: "selected-product-card"
  }, [_vm._m(1), _c('div', {
    staticClass: "product-summary"
  }, [_c('strong', [_vm._v(_vm._s(_vm.selectedProduct.descricao))]), _c('small', [_vm._v(_vm._s(_vm.productIdentifiers(_vm.selectedProduct)))]), _c('b', [_vm._v(_vm._s(_vm.formatPrice(_vm.selectedProduct.preco)))])]), _c('button', {
    staticClass: "btn btn-xs btn-light-primary font-weight-bold",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearSelection
    }
  }, [_vm._v(" Trocar ")])]) : [_c('div', {
    staticClass: "input-icon"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: _vm.search,
      expression: "search",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control form-control-sm",
    attrs: {
      "type": "search",
      "autocomplete": "off",
      "placeholder": "Descrição, código, referência ou EAN",
      "aria-label": "Buscar produto real para o teste"
    },
    domProps: {
      "value": _vm.search
    },
    on: {
      "input": [function ($event) {
        if ($event.target.composing) return;
        _vm.search = $event.target.value.trim();
      }, _vm.scheduleSearch],
      "blur": function blur($event) {
        return _vm.$forceUpdate();
      }
    }
  }), _c('span', [_c('i', {
    class: _vm.loading ? 'spinner spinner-sm spinner-primary' : 'flaticon2-search-1 text-muted'
  })])]), _vm.error ? _c('div', {
    staticClass: "product-picker-state error"
  }, [_c('i', {
    staticClass: "fas fa-exclamation-circle"
  }), _vm._v(_vm._s(_vm.error) + " ")]) : _vm.search && !_vm.loading && !_vm.results.length ? _c('div', {
    staticClass: "product-picker-state"
  }, [_vm._v(" Nenhum produto ativo encontrado nesta empresa. ")]) : !_vm.search ? _c('div', {
    staticClass: "product-picker-state"
  }, [_vm._v(" Digite para buscar entre os produtos ativos da empresa selecionada. ")]) : _vm._e(), _vm.results.length ? _c('div', {
    staticClass: "product-results"
  }, _vm._l(_vm.results, function (product) {
    return _c('button', {
      key: product.id,
      attrs: {
        "type": "button",
        "disabled": _vm.selectingId === product.id
      },
      on: {
        "click": function click($event) {
          return _vm.selectProduct(product);
        }
      }
    }, [_c('span', [_c('strong', [_vm._v(_vm._s(product.descricao))]), _c('small', [_vm._v(_vm._s(_vm.productIdentifiers(product)))])]), _c('b', [_vm._v(_vm._s(_vm.formatPrice(product.preco)))]), _c('i', {
      class: _vm.selectingId === product.id ? 'spinner spinner-sm spinner-primary' : 'fas fa-chevron-right'
    })]);
  }), 0) : _vm._e()]], 2);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('span', {
    staticClass: "etq-panel-kicker"
  }, [_vm._v("Dados reais do cliente")]), _c('h6', {
    attrs: {
      "id": "product-picker-title"
    }
  }, [_vm._v("Produto usado no teste")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('span', {
    staticClass: "product-icon"
  }, [_c('i', {
    staticClass: "fas fa-box"
  })]);
}];
export { render, staticRenderFns };